import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  resetPasswordSchema,
  forgetPasswordSchema,
  loginSchema,
  signupBasicDetailsWithEmailSchema,
  signupBasicDetailsWithGoogleSchema,
  signupOtherDetailsSchema,
  changePasswordSchema,
  editProfileFormSchema,
  addMachineSchema,
} from './auth.schema';

export const useLoginForm = () => {
  return useForm<z.infer<typeof loginSchema>>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });
};

export const useSignupBasicDetailsForm = (socialLogin: boolean) => {
  return useForm<
    | z.infer<typeof signupBasicDetailsWithGoogleSchema>
    | z.infer<typeof signupBasicDetailsWithEmailSchema>
  >({
    resolver: socialLogin
      ? zodResolver(signupBasicDetailsWithGoogleSchema)
      : zodResolver(signupBasicDetailsWithEmailSchema),
    defaultValues: socialLogin
      ? {
          profilePicture: '',
          username: '',
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          confirmPassword: '',
        }
      : {
          profilePicture: '',
          username: '',
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          confirmPassword: '',
        },
  });
};

export const useSignupOtherDetailsForm = () => {
  return useForm<z.infer<typeof signupOtherDetailsSchema>>({
    resolver: zodResolver(signupOtherDetailsSchema),
    defaultValues: {
      cncBrand: [],
      cncModel: [],
      cncVariant: [],
      locatedAt: '',
    },
  });
};

export const useForgetPasswordForm = () => {
  return useForm<z.infer<typeof forgetPasswordSchema>>({
    resolver: zodResolver(forgetPasswordSchema),
    defaultValues: {
      email: '',
    },
  });
};

export const useResetPasswordForm = () => {
  return useForm<z.infer<typeof resetPasswordSchema>>({
    resolver: zodResolver(resetPasswordSchema),
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });
};

export const useChangePasswordForm = () => {
  return useForm<z.infer<typeof changePasswordSchema>>({
    resolver: zodResolver(changePasswordSchema),
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  });
};

export const useEditProfileForm = (
  defaultValues?: z.infer<typeof editProfileFormSchema>
) => {
  return useForm<z.infer<typeof editProfileFormSchema>>({
    resolver: zodResolver(editProfileFormSchema),
    defaultValues,
  });
};

export const useAddMachineForm = () => {
  return useForm<z.infer<typeof addMachineSchema>>({
    resolver: zodResolver(addMachineSchema),
    defaultValues: {
      cncBrand: [],
      cncModel: [],
      cncVariant: [],
    },
  });
};
